import React, {
    createContext,
    FunctionComponent,
    PropsWithChildren,
    useContext,
    useReducer,
} from 'react';
import {ProductFormState} from './productFormActions';
import {ProductFormReducer, TypeOfProductFormAction} from './productFormReducer';

type Dispatcher = (action: TypeOfProductFormAction) => void;

export const DEFAULT_PRODUCT_FORM_STATE = {
    productToInspect: undefined,
    isInspectorOpen: false,
    isProductFormOpen: false,
    scrollTo: null,
};

const ProductFormContext = createContext<ProductFormState>(DEFAULT_PRODUCT_FORM_STATE);
const ProductFormDispatch = createContext<Dispatcher | undefined>(undefined);

export const ProductFormContextProvider: FunctionComponent<PropsWithChildren<{}>> = ({
    children,
}: PropsWithChildren<{}>) => {
    const [productFormState, dispatch] = useReducer(ProductFormReducer, DEFAULT_PRODUCT_FORM_STATE);

    return (
        <ProductFormContext.Provider value={productFormState}>
            <ProductFormDispatch.Provider value={dispatch}>{children}</ProductFormDispatch.Provider>
        </ProductFormContext.Provider>
    );
};

export const useProductFormStateDispatch = () => {
    const context = useContext(ProductFormDispatch);
    if (context === undefined) {
        throw new Error(
            'make sure to use productFormDispatch within the ProductFormContextProvider'
        );
    }

    return context;
};

export const useProductFormContext = () => {
    const context = useContext(ProductFormContext);
    if (context === undefined) {
        throw new Error('make sure to use productFormDispatch');
    }

    return context;
};

export default ProductFormContextProvider;
